import { fetchStore } from "../api/backend.js";

export const handlePrice = (price) => {
    return Number(price || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const fetchStoreData = async (_urlApi, shop) => {
    try {
        return await fetchStore(shop);
    } catch {
        return undefined;
    }
};

export const getFullAction = (selectedProducts) => {
    return selectedProducts.map(elem => {
        if (elem.action && elem.credit === true) return 'Receber vale-compras'
        else if (elem.action === 'Devolução' && (elem.credit === false || elem.credit === undefined)) return 'Receber reembolso'
        else if (elem.action === 'Troca' && elem.credit === false) return 'Trocar produto'
        else if (elem.action === 'Garantia') return 'Garantia'
        else return null
    });
};

export const updateProductsForCredit = (selectedProducts) => {
    return selectedProducts.map(product => {
        if (product.action === 'Devolução' && !product.credit) {
            return {
                ...product,
                credit: true
            };
        }
        return product;
    });
};

export const states = [
    { value: "", label: "Selecione", disabled: true },
    { value: "AC", label: "AC" }, { value: "AL", label: "AL" }, { value: "AP", label: "AP" },
    { value: "AM", label: "AM" }, { value: "BA", label: "BA" }, { value: "CE", label: "CE" },
    { value: "DF", label: "DF" }, { value: "ES", label: "ES" }, { value: "GO", label: "GO" },
    { value: "MA", label: "MA" }, { value: "MT", label: "MT" }, { value: "MS", label: "MS" },
    { value: "MG", label: "MG" }, { value: "PA", label: "PA" }, { value: "PB", label: "PB" },
    { value: "PR", label: "PR" }, { value: "PE", label: "PE" }, { value: "PI", label: "PI" },
    { value: "RJ", label: "RJ" }, { value: "RN", label: "RN" }, { value: "RS", label: "RS" },
    { value: "RO", label: "RO" }, { value: "RR", label: "RR" }, { value: "SC", label: "SC" },
    { value: "SP", label: "SP" }, { value: "SE", label: "SE" }, { value: "TO", label: "TO" },
];

export const optionsReasons = [
    { value: "", label: "Selecione o motivo", disabled: true },
    { value: "SIZE_TOO_SMALL", label: "Ficou pequeno", disabled: false },
    { value: "SIZE_TOO_LARGE", label: "Ficou grande", disabled: false },
    { value: "COLOR", label: "Não gostei da cor", disabled: false },
    { value: "STYLE", label: "Não gostei do estilo", disabled: false },
    { value: "DEFECTIVE", label: "Chegou com defeito", disabled: false },
    { value: "WRONG_ITEM", label: "Recebi o item errado", disabled: false },
    { value: "NOT_AS_DESCRIBED", label: "Diferente do anunciado", disabled: false },
    { value: "UNWANTED", label: "Não quero mais", disabled: false },
    { value: "OTHER", label: "Outro motivo", disabled: false },
]